<template>
        
    <sidebar-slot>
        <template v-slot:sidebar>

        </template>
    </sidebar-slot>

    <header>
        <header-slot>
            <template v-slot:header>

            </template>
        </header-slot>
    </header>

    <main-slot>
        <template v-slot:main>

        </template>
    </main-slot>

    <footer>
        <footer-slot>
            <template v-slot:footer>
                
            </template>
        </footer-slot>
    </footer>

</template>

<script>
import '@/static/css/style.css'
import '@/static/css/fixed.css'

// @ is an alias to /src
import headerSlot from '@/slot/headerSlot.vue'
import sidebarSlot from '@/slot/sidebarSlot.vue'
import mainSlot from '@/slot/mainSlot.vue'
import footerSlot from '@/slot/footerSlot.vue'
export default {
    components: {
        // naviBar
        'header-slot' : headerSlot,
        'sidebar-slot' : sidebarSlot,
        'main-slot': mainSlot,
        'footer-slot': footerSlot,
    },
    data: function() {
        return {
            // IS_SHOW_NAVI: false,
            // NO_SHOW_NAVI_URL_LIST: ['login', 'signUpMember'],   // 보여줄것으로 관리함//
            // SHOW_NAVI_URL_LIST: ['home','iwCntn','kakao']
        }
    },
    methods: {
        // init: function() {
        //     this.setShowNavi(window.location.href);
        // },
        // viewer: function(opt) {
        //     return viewer.get(opt);
        // },
        // loader: function(to) {
        //     console.log(to);
        // },
        // setShowNavi: function(path) {
        //     this.IS_SHOW_NAVI = false;
        //     for ( let i = 0 ; i < this.SHOW_NAVI_URL_LIST.length ; i++ ) {
        //         if ( path.indexOf(this.SHOW_NAVI_URL_LIST[i]) > -1 ) {
        //             this.IS_SHOW_NAVI = true;
        //         }
        //     }
        //     // console.log(path + "/" + this.IS_SHOW_NAVI);
        // }
    },
    watch: {
        // $route (to, from) {
        //     // this.loader(to.path);
        //     // console.log(from.path + '->' + to.path);
        //     this.setShowNavi(to.path);

        //     if ( from.path.indexOf('signUpMember') > -1 && to.path.indexOf('login') > -1 ) {
        //         router.push('/home');
        //     }

        //     // LayerUtil.init();
        // }
    },
    computed: {
        
    },
    mounted() {
        // this.init();
        // this.loader(this.$router.currentRoute.path);
    }
}
</script>